export const PIPELINE_COLUMN_PREFIX = 'pipeline-column:';
export const PIPELINE_CARD_PREFIX = 'pipeline-card:';

export const getPipelineColumnId = (stage) => `${PIPELINE_COLUMN_PREFIX}${stage}`;

export const pipelineBoardId = (card) => {
  if (!card) return null;
  if (card.boardId) return card.boardId;
  if (card.cardType === 'inquiry') return `inquiry:${card.inquiryId || card.id}`;
  return `trip:${card.tripId || card.id}`;
};

export const getPipelineCardId = (cardOrBoardId) => {
  if (cardOrBoardId && typeof cardOrBoardId === 'object') {
    return `${PIPELINE_CARD_PREFIX}${pipelineBoardId(cardOrBoardId)}`;
  }
  return `${PIPELINE_CARD_PREFIX}${cardOrBoardId}`;
};

export const shouldMovePipelineTrip = ({ boardId, tripId, fromStage, toStage }) => (
  (boardId != null || tripId != null)
  && Boolean(toStage)
  && toStage !== fromStage
);

export const resolvePipelineDrop = (event) => {
  const active = event?.active;
  const over = event?.over;
  if (!active || !over) return null;

  const data = active.data?.current || {};
  const boardId = data.boardId || (data.tripId != null ? `trip:${data.tripId}` : null);
  const fromStage = data.stage;
  const toStage = over.data?.current?.stage;
  if (!shouldMovePipelineTrip({ boardId, tripId: data.tripId, fromStage, toStage })) return null;

  return {
    boardId,
    fromStage,
    toStage,
    cardType: data.cardType || 'trip',
    tripId: data.tripId,
    inquiryId: data.inquiryId,
  };
};

export const applyPipelineStage = (trips, boardId, stage) => (
  (trips || []).map((trip) => (
    pipelineBoardId(trip) === boardId ? { ...trip, pipeline_stage: stage } : trip
  ))
);
